import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useAuth } from '../../context/AuthContext';

const titles = {
  '/':              'Dashboard',
  '/courses':       'Courses',
  '/attendance':    'Attendance',
  '/psr':           'PSR Score',
  '/psr-report':    'Status Report',
  '/job-timeline':  'Work History',
  '/profile':       'Profile',
  '/users':         'User Management',
  '/course-builder':'Course Builder',
  '/assignments':   'Assignments',
  '/attendance-mgr':'Attendance Management',
  '/psr-mgr':       'PSR Management',
  '/psr-review':    'Review Status Reports',
  '/csv-import':    'CSV Import',
  '/reports':       'Reports',
};

export default function Layout() {
  const [showSidebar, setShowSidebar] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { user, isSupervisor } = useAuth();
  const location = useLocation();
  const title = titles[location.pathname] || 'LMS';

  return (
    <>
      <Sidebar
        show={showSidebar}
        onClose={() => setShowSidebar(false)}
        onCollapseChange={setSidebarCollapsed}
      />
      {/* Mobile overlay */}
      {showSidebar && (
        <div
          style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.45)', zIndex:999 }}
          className="d-md-none"
          onClick={() => setShowSidebar(false)}
        />
      )}

      <div className={`main-content${sidebarCollapsed ? ' sidebar-collapsed' : ''}`}>
        {/* Top header — matches CP style */}
        <div className="top-header">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-link text-dark p-0 d-md-none"
              onClick={() => setShowSidebar(true)}
              style={{ fontSize: '1.25rem', lineHeight: 1 }}
            >
              <i className="bi bi-list" />
            </button>
            <div>
              <h6 className="mb-0 fw-bold" style={{ color: '#1e293b' }}>{title}</h6>
            </div>
          </div>
          <div className="d-flex align-items-center gap-2">
            <span
              className="badge"
              style={{
                background: isSupervisor ? '#fef9c3' : '#dbeafe',
                color:      isSupervisor ? '#854d0e' : '#1d4ed8',
                fontWeight: 600, fontSize: '.6875rem', padding: '.3em .65em',
                borderRadius: '50px',
              }}
            >
              {isSupervisor ? 'Admin' : 'Employee'}
            </span>
            <span style={{ fontSize: '.8125rem', color: '#64748b', fontWeight: 500 }}>{user?.name}</span>
          </div>
        </div>

        <Outlet />
      </div>
    </>
  );
}
